module.exports = __webpack_public_path__ + "img/attach-icon.4b4ff5fe.svg";